import {
  CommonButton,
  GlobalLoader,
  InnerFooter,
  NoDataFound,
  RippleEffect,
  SubscriptionPlanCard,
} from "components";
import { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import routesMap from "routeControl/userRouteMap";
import { AdminManageSubscriptionService } from "services";
import { logger, setSessionStorage } from "utils";

function ChoosePlan({ setKey, activeKey }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [active, setActive] = useState({});

  const getAllSubscriptionData = async () => {
    setLoading(true);
    try {
      const { data, success } =
        await AdminManageSubscriptionService.getSubscriptionList();
      if (success && data) {
        setSubscriptionData(data?.rows);
        setActive(data?.key);
      }
    } catch (err) {
      logger(err);
    }
    setLoading(false);
  };

  const onBuyPlan = async (item) => {
    setSessionStorage("cardData", item);
    navigate(`${routesMap?.PAYMENT?.path}/${item?.layout}`);
  };

  useEffect(() => {
    if (activeKey && activeKey === "plans") {
      getAllSubscriptionData();
    }
  }, [activeKey]);

  useEffect(() => {
    if (!activeKey) {
      getAllSubscriptionData();
    }
  }, []);

  return (
    <>
      <main className={`${!setKey && "bg-light-grey py-50 pb-0 mainModule"}`}>
        {!setKey && (
          <section className="pageTitle">
            <Container>
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <h1 className="fw-semibold">{t("text.common.choosePlan")}</h1>
                  <p className="mb-0">{t("text.common.yourJourney")}</p>
                </div>
                <RippleEffect extraClassName="d-inline-box">
                  <CommonButton
                    variant="btn text-dark btn-outline-light"
                    onClick={() => navigate(routesMap?.USERDASHBOARD?.path)}
                  >
                    {t("text.common.skip")}
                  </CommonButton>
                </RippleEffect>
              </div>
            </Container>
          </section>
        )}
        {loading ? (
          <GlobalLoader />
        ) : (
          <section className="subscriptionPlan pt-0 py-80" id="priceplan">
            <Container>
              <Row sm={2} md={3} className="align-items-end gx-3 gx-lg-4">
                {subscriptionData?.length > 0 ? (
                  subscriptionData.map((item, index) => {
                    return (
                      <SubscriptionPlanCard
                        item={item}
                        key={index}
                        t={t}
                        loading={loading}
                        onHandleClick={onBuyPlan}
                        active={active}
                        isPayment={item?.isPayment}
                      />
                    );
                  })
                ) : (
                  <NoDataFound />
                )}
              </Row>
            </Container>
          </section>
        )}
      </main>
      {!setKey && <InnerFooter />}
    </>
  );
}

export default ChoosePlan;
